var _animate;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 205,
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      display: "block"
    },
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#354497",
    strokeDasharray: "42.76482137044271 42.76482137044271",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40C88.6 30 95 43.3 95 50s-6.4 20-19.3 20c-19.3 0-32.1-40-51.4-40z",
    style: {
      transform: "scale(.8300000000000001)",
      transformOrigin: "50px 50px"
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "2.4390243902439024s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "0;256.58892822265625"
  }))));
};
export default SvgLoading;